<script lang="ts" setup>
import type { MenuItem } from '@bloomreach/spa-sdk'
import { type PropType, computed } from 'vue'
import { useHeader } from '@/cms-ui/composables/useHeader'
import { useClickTracking } from '@/cms-ui/composables/useAnalytics'
import { EClickElement } from '@/cms-ui/utils/dataLayer'

const props = defineProps({
    item: {
        type: Object as PropType<MenuItem>,
        required: true,
    },
    isOpen: {
        type: Boolean,
        default: false,
    },
    index: {
        type: Number,
        default: null,
    },
})

const { isDesktopMenuOpen, toggleDesktopDrawerMenu, getTarget } = useHeader()

const isButton = !props.item.getUrl()

const computedClass = computed(() => {
    if (props.isOpen) {
        return 'text-brand-accent-on-dark'
    } else if (isDesktopMenuOpen.value) {
        return 'text-comp-high-contrast-on-dark'
    } else {
        return 'text-comp-high-contrast'
    }
})
</script>

<template>
    <component
        :is="isButton ? 'button' : 'a'"
        :href="isButton ? null : item.getUrl()"
        :target="getTarget(item)"
        class="label-lg px-sm py-base flex hover:underline"
        :class="[computedClass, { 'whitespace-nowrap': isButton }]"
        @click="[
            isButton ? toggleDesktopDrawerMenu(index, item) : null,
            useClickTracking({
                label: item.getName(),
                clickPath: item.getUrl() || '',
                clickElement: EClickElement.TEXT,
                componentName: 'header',
                componentCategory: 'menu',
            }),
        ]"
    >
        {{ item.getName() }}

        <VIcon
            v-if="!item.getUrl()"
            name="chevron-down"
            size="MEDIUM"
            class="ml-2xs transition-transform"
            :class="{ 'rotate-180': isOpen }"
        />
    </component>
</template>
